import React from 'react';
import { useTranslation } from 'react-i18next';
import { QAlertBox, QFlex, QAlertTitle, QSpacer, QButton } from '@qualio/ui-components';

type ReviewRequestBannerProps = {
  markAsReviewedButtonClick: () => void;
};

export const ReviewRequestBanner: React.FC<ReviewRequestBannerProps> = ({ markAsReviewedButtonClick }) => {
  const { t } = useTranslation();
  return (
    <QAlertBox status="warning" alignItems="center">
      <QFlex alignItems="baseline">
        <QAlertTitle>{t('common.notifications.reviewRequest')}</QAlertTitle>
        <QSpacer />
        <QButton data-cy="mark-as-reviewed-button" variant="solid" onClick={markAsReviewedButtonClick}>
          {t('forms.actions.markAsReviewed')}
        </QButton>
      </QFlex>
    </QAlertBox>
  );
};

export default ReviewRequestBanner;
